
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';
    import { Envio } from '@/__env/lib/Ventas/Envios';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        @Watch( 'Estado' )
        onEstado()
        {
            this.$emit( 'estado', this.Estado );
        }

        async mounted()
        {
            this.Iniciar();
        }

        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );
            await this.Pedido.CargarItems();
            this.Estado = 'ok';

        }



    }
